var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.storedAlertNotification.show && _vm.isModal === _vm.alertSendToModal)?_c('dean-alert-dialog',{staticClass:"notification",attrs:{"data":_vm.storedAlertNotification.type,"theme":_vm.storedAlertNotification.type.theme},on:{"close":_vm.closeNotification}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }